import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, OnInit } from '@angular/core';
import { MenuNavigation } from '../../navigation';

import { ArrayDataSource } from '@angular/cdk/collections';
import { NavigationService } from '../../services/navigation.service';
import { AuthService } from '../../services/auth.service';
import { ConnectionService, Connection } from '../../services/connection.service';
import { Router } from '@angular/router';

@Component({
  selector: 'side-navigation',
  templateUrl: './side-navigation.component.html',
  styleUrls: ['./side-navigation.component.scss']
})
export class SideNavigationComponent implements OnInit {

  showFiller = false;
  minimised = false;
  isOpen = false;

  treeControl = new FlatTreeControl<MenuNavigation>(
  node => node.level, node => node.expandable);

  dataSource = new ArrayDataSource(this.navigationService.navigationStructure);

  hasChild = (_: number, node: MenuNavigation) => node.expandable;

  constructor(
    private navigationService: NavigationService,
    private authService: AuthService,
    public connectionService: ConnectionService,
    public router: Router
    ) { }

  ngOnInit(): void {
    console.log("hit")
    if (!this.authService.isAuthenticated()) {
      this.minimised = true;
      console.log("hit2")
    }
  }

  getParentNode(node: MenuNavigation) {
    const nodeIndex = this.navigationService.navigationStructure.indexOf(node);

    for (let i = nodeIndex - 1; i >= 0; i--) {
      if (this.navigationService.navigationStructure[i].level === node.level - 1) {
        return this.navigationService.navigationStructure[i];
      }
    }

    return null;
  }

  shouldRender(node: MenuNavigation) {
    let parent = this.getParentNode(node);
    while (parent) {
      if (!parent.isExpanded) {
        return false;
      }
      parent = this.getParentNode(parent);
    }
    return true;
  }

  open(node: MenuNavigation) {
    const shouldExpand = !node.isExpanded;

    if (shouldExpand) {
      this.navigationService.navigationStructure
        .filter(candidate => candidate !== node && candidate.expandable && candidate.level === node.level)
        .forEach(candidate => candidate.isExpanded = false);
    }

    node.isExpanded = shouldExpand;

    if (node.route != undefined) {
      this.router.navigate([node.route]);
    }

  }

  close() {
    this.isOpen = false;
  }

  logout() {
    this.navigationService.hide = true;
    this.close();
    this.authService.logout();
  }

  navigate (address: string) {
    this.router.navigate([address]);

    // Only close on mobile
    if (window.innerWidth < 800) {
      this.navigationService.hide = true;
      this.close();
    }
  }

  switchConnection(connection: Connection) {
    console.log("HIT");
    this.connectionService.switchTo(connection);
    this.router.navigate(["/dashboard"]).then(()=> {
      this.close();
      window.location.reload()
    });
  }
}
